import {
  ChevronUp,
  Edit,
  PlusCircle,
  Eye,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { secureExportToExcel } from "../../utils/secureExcelUtils";
import { Tabs, Popconfirm, List } from "antd";
import AgGridWithColumnState from "../components/AgGridWithColumnState";
import AgGridWithAdvancedColumnState from "../components/AgGridWithAdvancedColumnState";

const MarketingOffers = ({
  data,
  tabKeyToPath,
  handleAddNewMarketing,
  setClientId,
  setIsRightSideBarEditMode,
  setSidebarVisible,
  setOfferId,
  setPrintId,
  selectedClients,
  searchQuery,
  handleSearch,
  marketings,
  setPage,
  setPageSize,
  fetchMarketings,
  loading,
  dataLoaded,
  filteredMarketings,
  tableContainerRef,
  gridApiRef,
  page,
  pageSize,
  totalItems,
  totalPages,
  setToogleHeader,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const columnDefs = [
    {
      headerName: "#",
      valueGetter: (params) => {
        // Calculate continuous row index across pages
        return (page - 1) * pageSize + params.node.rowIndex + 1;
      },
      width: 50,
      sortable: false,
      filter: false,
    },
    {
      headerName: "Brand",
      field: "brand_name",
      width: 150,
    },
    {
      headerName: "Status",
      field: "status.name",
      width: 160,
      cellRenderer: (params) => {
        const value = params.value;
        const badgeClass =
          value === "Confirmed"
            ? "badge bg-success"
            : value === "Pending"
            ? "badge bg-warning"
            : "badge bg-danger";
        return <span className={badgeClass}>{value}</span>;
      },
    },
    {
      headerName: "Product Variation Description",
      field: "product_variations_detail",
      width: 270,
      cellRenderer: (params) => {
        const variations = params.value;
        if (!Array.isArray(variations)) return "";
        return (
          <ul className="mb-0">
            {variations.map((variation) => (
              <li key={variation.id}>
                <span
                  className="clickable-link"
                  onClick={() => {
                    navigate(
                      `/products/view/${variation.client}/${variation.product_id}${
                        variation.id ? `/${variation.id}` : ""
                      }${variation.warehouseId ? `/${variation.warehouseId}` : ""}`
                    );
                  }}>
                  <u>{variation.description}</u>
                </span>
              </li>
            ))}
          </ul>
        );
      },
    },
    {
      headerName: "Type of Offer",
      field: "type_of_offer.type_of_offer",
      width: 140,
    },
    {
      headerName: "Form of Offer",
      field: "form_of_offer.form_of_offer",
      width: 120,
    },
    {
      headerName: "Code Offer",
      field: "code_offer",
      width: 150,
      cellRenderer: (params) => {
        const record = params.data;
        return (
          <span
            className="clickable-link"
            onClick={() => {
              setClientId(record.client.id);
              setOfferId(record.id);
              setIsRightSideBarEditMode(false);
              setSidebarVisible(true);
            }}>
            <u>{record.code_offer}</u>
          </span>
        );
      },
    },
    {
      headerName: "Marketing SKUs",
      field: "marketing_skus",
      width: 150,
      cellRenderer: (params) => {
        const skus = params.value || [];
        if (!Array.isArray(skus) || skus.length === 0) return "No SKUs";

        if (skus.length === 1) {
          return <span>{skus[0].sku}</span>;
        }

        return (
          <Popconfirm
            title="Marketing SKUs"
            description={
              <div style={{ maxHeight: "200px", overflowY: "auto", width: "300px" }}>
                <List
                  size="small"
                  dataSource={skus}
                  renderItem={(sku) => (
                    <List.Item>
                      <div>
                        <strong>{sku.sku}</strong>
                        {sku.is_bundle && (
                          <span style={{ color: "#1890ff", marginLeft: "8px" }}>
                            (Bundle - ${sku.total_bundle_price || 0})
                          </span>
                        )}
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            }
            showCancel={false}
            okText="Close"
            trigger="click">
            <span style={{ cursor: "pointer", color: "#1890ff" }}>{skus.length} SKUs</span>
          </Popconfirm>
        );
      },
    },
    {
      headerName: "Marketing Files",
      field: "marketing_files",
      width: 150,
      cellRenderer: (params) => {
        const files = params.value || [];
        if (!Array.isArray(files) || files.length === 0) return "No Files";

        if (files.length === 1) {
          return <span>{files[0].file_name || files[0].file_code}</span>;
        }

        return (
          <Popconfirm
            title="Marketing Files"
            description={
              <div style={{ maxHeight: "200px", overflowY: "auto", width: "350px" }}>
                <List
                  size="small"
                  dataSource={files}
                  renderItem={(file) => (
                    <List.Item>
                      <div>
                        <strong>{file.file_name || file.file_code}</strong>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                          {file.type_name && <span>Type: {file.type_name}</span>}
                          {file.number_of_pages && (
                            <span style={{ marginLeft: "8px" }}>Pages: {file.number_of_pages}</span>
                          )}
                          {(file.length || file.width) && (
                            <span style={{ marginLeft: "8px" }}>
                              Size: {file.length}×{file.width}
                            </span>
                          )}
                        </div>
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            }
            showCancel={false}
            okText="Close"
            trigger="click">
            <span style={{ cursor: "pointer", color: "#1890ff" }}>{files.length} Files</span>
          </Popconfirm>
        );
      },
    },
    {
      headerName: "Payment Details",
      field: "payment_details.detail",
      width: 140,
    },
    {
      headerName: "Gift Visible",
      field: "gift_visible_in_offer",
      width: 120,
    },
    {
      headerName: "Printer",
      field: "print_stock.printer_name",
      width: 100,
    },
    {
      headerName: "Qty Printed",
      field: "print_stock.qty_printed",
      width: 110,
      valueFormatter: (p) => p.value || 0,
    },
    {
      headerName: "Total Value Print",
      field: "print_stock.total_value_print",
      width: 110,
      valueFormatter: (p) => `$${(p.value || 0).toFixed(3)}`,
    },
    {
      headerName: "Unit Price",
      field: "unit_price",
      width: 110,
      valueGetter: (params) => {
        const { qty_printed, total_value_print } = params.data.print_stock || {};
        const unitPrice = qty_printed > 0 ? total_value_print / qty_printed : 0;
        return `$${unitPrice.toFixed(3)}`;
      },
    },
    {
      headerName: "Total Qty Used",
      field: "print_stock.total_qty_used",
      width: 110,
      valueFormatter: (p) => p.value || 0,
    },
    {
      headerName: "Stock Remaining",
      field: "stock_remaining",
      width: 120,
      valueGetter: (params) => {
        const { qty_printed = 0, total_qty_used = 0 } = params.data.print_stock || {};
        return qty_printed - total_qty_used;
      },
    },
    {
      headerName: "Value Stock Remaining",
      field: "value_stock_remaining",
      width: 120,
      valueGetter: (params) => {
        const {
          qty_printed = 0,
          total_qty_used = 0,
          total_value_print = 0,
        } = params.data.print_stock || {};
        const unitPrice = qty_printed > 0 ? total_value_print / qty_printed : 0;
        const remaining = qty_printed - total_qty_used;
        return `$${(remaining * unitPrice).toFixed(3)}`;
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      width: 100,
      cellRenderer: (params) => {
        const record = params.data;
        return (
          <div className="action-table-data edit-delete-action d-flex gap-1">
            <a
              className="p-1"
              title="View"
              onClick={() => {
                setClientId(record.client.id);
                setOfferId(record.id);
                setIsRightSideBarEditMode(false);
                setSidebarVisible(true);
                setPrintId(record.print_stock?.id);
              }}>
              <Eye className="feather-view" style={{ width: 16, height: 16 }} />
            </a>

            <a
              className="p-1"
              title="Edit"
              onClick={async () => {
                setOfferId(record.id);
                setClientId(record.client.id);
                navigate(`/marketing/${tabKeyToPath[3]}/${record.id}`);
              }}>
              <Edit className="feather-edit" style={{ width: 16, height: 16 }} />
            </a>
          </div>
        );
      },
    },
  ];
  const exportToExcel = async () => {
    const exportColumns = [
      { title: "Brand", dataIndex: "brand_name" },
      { title: "Offer Code", dataIndex: "code_offer" },
      {
        title: "Offer Type",
        dataIndex: "type_of_offer",
        transform: (item) => item?.type_of_offer?.type_of_offer || "",
      },
      {
        title: "Form",
        dataIndex: "form_of_offer",
        transform: (item) => item?.form_of_offer?.form_of_offer || "",
      },
      {
        title: "Status",
        dataIndex: "status",
        transform: (item) => item?.status?.name || "",
      },
      {
        title: "Marketing SKUs",
        dataIndex: "marketing_skus",
        transform: (item) => {
          const skus = item?.marketing_skus || [];
          return skus.map((sku) => sku.sku).join(", ");
        },
      },
      {
        title: "Marketing Files",
        dataIndex: "marketing_files",
        transform: (item) => {
          const files = item?.marketing_files || [];
          return files.map((file) => file.file_name || file.file_code).join(", ");
        },
      },
    ];

    const exportData = marketings.map((item) => {
      const row = {};
      exportColumns.forEach((col) => {
        if (col.transform) {
          row[col.title] = col.transform(item);
        } else {
          row[col.title] = item[col.dataIndex] || "";
        }
      });
      return row;
    });

    secureExportToExcel(exportData, "marketing_list.xlsx");
  };

  return (
    <div
      className="marketing-offers-container"
      style={{
        width: "100%",
        height: "calc(100vh - 140px)", // Increased from 120px to account for tiny mismatch
        display: "flex",
        flexDirection: "column",
        transition: "width 0.3s ease-in-out",
        overflow: "hidden", // Prevent external scrolling
      }}>
      <div className="page-header" style={{ flexShrink: 0 }}>
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>Marketing Offers</h4>
          </div>
        </div>
        <ul className="table-top-head">
          <div className="search-set">
            <div className="search-input">
              <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm formsearch"
                value={searchQuery}
                onChange={handleSearch}
              />
              <Link to="#" className="btn btn-searchset">
                <i data-feather="search" className="feather-search" />
              </Link>
            </div>
          </div>
          <li>
            <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
              <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={exportToExcel}>
                <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />
              </Link>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
              <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={fetchMarketings}>
                <RotateCcw />
              </Link>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
              <Link
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                id="collapse-header"
                className={data ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setToogleHeader(!data));
                }}>
                <ChevronUp />
              </Link>
            </OverlayTrigger>
          </li>
        </ul>

        <div className="page-btn">
          <button className="btn btn-added" onClick={handleAddNewMarketing}>
            <PlusCircle className="me-2 iconsize" />
            Add New Marketing
          </button>
        </div>
      </div>
      <div
        className="table-container"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minHeight: 0,
        }}>
        <div
          className="table-responsive"
          ref={tableContainerRef}
          style={{
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}>
          <div
            className="ag-theme-quartz position-relative"
            style={{
              flex: 1,
              width: "100%",
              minHeight: 0,
              overflow: "hidden",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }}>
            <style
              dangerouslySetInnerHTML={{
                __html: `
                .ag-grid-no-bottom-radius .ag-root-wrapper {
                  border-bottom-left-radius: 0 !important;
                  border-bottom-right-radius: 0 !important;
                }
                .ag-grid-no-bottom-radius .ag-root {
                  border-bottom-left-radius: 0 !important;
                  border-bottom-right-radius: 0 !important;
                }
                .ag-grid-no-bottom-radius .ag-body-viewport {
                  border-bottom-left-radius: 0 !important;
                  border-bottom-right-radius: 0 !important;
                }
              `,
              }}
            />
            {/* Loading Overlay */}
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  zIndex: 1000,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}>
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{ width: "3rem", height: "3rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: "15px", fontWeight: "bold" }}>
                  Loading marketing offers...
                </div>
              </div>
            )}
            <AgGridWithAdvancedColumnState
              tableId="marketing-offers-table"
              gridApiRef={gridApiRef}
              columnDefs={columnDefs}
              rowData={filteredMarketings}
              defaultColDef={{
                resizable: true,
                sortable: true,
                filter: true,
                minWidth: 50,
              }}
              pagination={true}
              paginationPageSize={pageSize}
              suppressPaginationPanel={true}
              domLayout="normal"
              rowModelType="clientSide"
              gridOptions={{
                getRowStyle: () => ({
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                }),
              }}
              className="ag-grid-no-bottom-radius"
              style={{
                height: "100%",
                width: "100%",
              }}
              onGridReady={(params) => {
                console.log(
                  "🚀 Marketing grid ready, loading:",
                  loading,
                  "dataLoaded:",
                  dataLoaded
                );

                // Store the grid API reference first
                if (!gridApiRef.current) {
                  gridApiRef.current = params.api;
                }

                // If we're currently loading data, show the loading overlay but don't fetch again
                if (loading) {
                  params.api.showLoadingOverlay();
                  return; // Exit early to prevent additional fetch
                }

                // Only fetch data on grid ready if:
                // 1. We haven't loaded data yet AND
                // 2. We're not already loading AND
                // 3. We have valid selectedClients AND
                // 4. The parent component hasn't already initiated a fetch (initialLoadComplete check)
                if (!dataLoaded && !loading && selectedClients && selectedClients.length > 0) {
                  console.log("📊 Grid ready triggered data fetch");
                  fetchMarketings(page, pageSize);
                } else if (dataLoaded && filteredMarketings.length > 0) {
                  // Only set pagination if we have data and it's not the initial load
                  setTimeout(() => {
                    if (params.api && page > 1) {
                      params.api.paginationGoToPage(page - 1);
                    }
                  }, 0);
                }
              }}
              onPaginationChanged={(params) => {
                // Prevent pagination changes during loading or if API is not available
                if (!params.api || loading) {
                  console.log("⏸️ Pagination change blocked - loading or no API");
                  return;
                }

                if (params.api.paginationProxy) {
                  const newPage = params.api.paginationProxy.getCurrentPage() + 1;
                  const newPageSize = params.api.paginationProxy.getPageSize();

                  // Only fetch if the page or pageSize actually changed and we're not loading
                  if ((newPage !== page || newPageSize !== pageSize) && !loading) {
                    console.log(
                      `📄 Pagination changed: ${page} → ${newPage}, Size: ${pageSize} → ${newPageSize}`
                    );

                    // Show loading overlay before fetching data
                    params.api.showLoadingOverlay();
                    setPage(newPage);
                    setPageSize(newPageSize);
                    fetchMarketings(newPage, newPageSize);
                  }
                }
              }}
              overlayNoRowsTemplate="<span style='padding: 10px'>No marketing offers found</span>"
              overlayLoadingTemplate="<span style='padding: 10px'>Loading marketing offers...</span>"
            />
          </div>

          <div
            className="custom-pagination-footer border rounded-bottom-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 20px",
              // borderTop: "1px solid #ddd",
              // backgroundColor: "white",
              zIndex: 1000,
              // boxShadow: "0 -2px 5px rgba(0,0,0,0.3)",
              flexShrink: 0,
              minHeight: "60px", // Ensure minimum height for pagination
            }}>
            <div className="pagination-info">
              Showing {filteredMarketings.length > 0 ? (page - 1) * pageSize + 1 : 0} to{" "}
              {Math.min(page * pageSize, totalItems)} of {totalItems} entries
            </div>
            <div
              className="pagination-controls"
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}>
              <div className="page-size-selector">
                <select
                  value={pageSize}
                  onChange={(e) => {
                    const newSize = parseInt(e.target.value);
                    setPageSize(newSize);
                    fetchMarketings(1, newSize);
                  }}
                  style={{
                    padding: "5px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                  }}>
                  {[10, 25, 50, 100, 500, 1000, 2000, 5000].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </div>
              <div className="page-navigation" style={{ display: "flex", gap: "5px" }}>
                <button
                  onClick={() => fetchMarketings(1, pageSize)}
                  disabled={page === 1}
                  style={{
                    padding: "5px 10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: page === 1 ? "not-allowed" : "pointer",
                    opacity: page === 1 ? 0.5 : 1,
                  }}>
                  First
                </button>
                <button
                  onClick={() => fetchMarketings(page - 1, pageSize)}
                  disabled={page === 1}
                  style={{
                    padding: "5px 10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: page === 1 ? "not-allowed" : "pointer",
                    opacity: page === 1 ? 0.5 : 1,
                  }}>
                  Previous
                </button>
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (page <= 3) {
                    pageNum = i + 1;
                  } else if (page >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = page - 2 + i;
                  }

                  return (
                    <button
                      key={pageNum}
                      onClick={() => fetchMarketings(pageNum, pageSize)}
                      style={{
                        padding: "5px 10px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        backgroundColor: page === pageNum ? "#007bff" : "white",
                        color: page === pageNum ? "white" : "black",
                      }}>
                      {pageNum}
                    </button>
                  );
                })}
                <button
                  onClick={() => fetchMarketings(page + 1, pageSize)}
                  disabled={page === totalPages}
                  style={{
                    padding: "5px 10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: page === totalPages ? "not-allowed" : "pointer",
                    opacity: page === totalPages ? 0.5 : 1,
                  }}>
                  Next
                </button>
                <button
                  onClick={() => fetchMarketings(totalPages, pageSize)}
                  disabled={page === totalPages}
                  style={{
                    padding: "5px 10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: page === totalPages ? "not-allowed" : "pointer",
                    opacity: page === totalPages ? 0.5 : 1,
                  }}>
                  Last
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingOffers;
